import React, { useState } from "react";
import ReactHelmet from "./components/ReactHelmet";
import BannerLine from "./assets/banner/banner-line.webp";
import LogoSection from "./components/LogoSection";
import BannerBottom from "./components/BannerBottom";
import Header from "./components/Header";
import Slide from "./components/Slide";
import Collaboration from "./components/Collaboration";
import Advantages from "./components/Advantages";
import Application from "./components/Application";
import FAQ from "./components/FAQ";
import NavbarComp from "./components/NavbarComp";
import Contact from "./components/Contact";
import { RiMessage2Fill } from "react-icons/ri";
import { Link } from "react-router-dom";
import FooterMenu from "./components/FooterMenu";
import Footer from "./components/Footer";
import languageStorage from "./lang/findLanguage";
import languages from "./lang/languages";
import EmailPopup from "./components/EmailPopup";

export default function Home() {
  const [language] = useState(languages);

  return (
    <>
      <ReactHelmet
        titleName={
          languageStorage() === "tr"
            ? language[0].header[0].titleName
            : language[1].header[0].titleName
        }
        description={
          languageStorage() === "tr"
            ? language[0].header[0].description
            : language[1].header[0].description
        }
        canonical={
          languageStorage() === "tr"
            ? language[0].header[0].canonical
            : language[1].header[0].canonical
        }
      />
      <main className='main'>
        <NavbarComp />
        <Header language={language} />
        <img className='banner-line' src={BannerLine} alt='' width='100%' />
        <BannerBottom language={language} />
        <LogoSection language={language} />
        <Slide language={language} />
        <Collaboration language={language} />
        <Advantages language={language} />
        <Application language={language} />
        <div
          id={
            languageStorage() === "tr"
              ? language[0].sections[11].keys[4].k0005
              : language[1].sections[11].keys[4].k0005
          }
          style={{ marginBottom: "72px", color: "#fff" }}
        >
          ...
        </div>
        <FAQ language={language} />
        <div
          id={
            languageStorage() === "tr"
              ? language[0].sections[11].keys[5].k0006
              : language[1].sections[11].keys[5].k0006
          }
          style={{ marginBottom: "70px", color: "#fff" }}
        >
          ...
        </div>
        <Contact language={language} />

        <Link
          to='#'
          onClick={() =>
            window.open(
              `https://api.whatsapp.com/send?phone=+90 535 942 96 79&text=${
                languageStorage() === "tr"
                  ? language[0].sections[13].keys[0].k0001
                  : language[1].sections[13].keys[0].k0001
              }`,
              "_blank"
            )
          }
          className='whatsapp-icon'
        >
          <RiMessage2Fill size='28' color='red' />
        </Link>
        <FooterMenu language={language} />
        <Footer language={language} />
        <EmailPopup language={language} />
      </main>
    </>
  );
}
